import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import chroma from 'chroma-js';
import countriesGeoJson from '../data/ne_110m_admin_0_countries.geo';
import './leaflet-gesture-handling.css';
import './leaflet-gesture-handling.js';

import './Mapa.css';

const fadedColor = '#ddd';
const borderColor = '#fff';
const selectedBorderColor = '#fff';

export class Mapa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      atributoSeleccionado: null
    };
    this.map = null;
    this.maximo = null;
    this.countryColor = null;
    this.geojson = null;
    this.selectedLayer = null;
  }

  render() {
    const t = this.props.t;
    document.styleSheets[0].insertRule(
      `.leaflet-gesture-handling-scroll-warning:after { content: '${t('mensajeMapaScroll')}'`,
      0
    );
    document.styleSheets[0].insertRule(
      `.leaflet-gesture-handling-scroll-warning.mac:after { content: '${t(
        'mensajeMapaScrollMac'
      )}'`,
      0
    );
    document.styleSheets[0].insertRule(
      `.leaflet-gesture-handling-touch-warning:after { content: '${t('mensajeMapaTouch')}'`,
      0
    );
    document.styleSheets[0].cssRules[0].style.backgroundColor = 'red';
    return <div id="mapa" className={this.props.className} style={this.props.style} />;
  }
  componentWillMount() {
    this.setState({
      atributoSeleccionado: this.props.atributoSeleccionado
    });
  }
  componentDidMount() {
    this.renderMap(this.props.datos.paisesPorIso, this.props.datos.maximos);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.atributoSeleccionado === this.props.atributoSeleccionado) {
      return;
    }
    let newState = { ...this.state };
    newState.atributoSeleccionado = nextProps.atributoSeleccionado;
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.atributoSeleccionado === this.props.atributoSeleccionado) {
      return false;
    }
    this.maximo = this.props.datos.maximos[this.state.atributoSeleccionado];
    if (this.maximo.hasOwnProperty('nombre')) {
      this.maximo = this.maximo.valor;
    }
    this.countryColor.domain([0, this.maximo]);
    this.geojson.eachLayer(layer => {
      layer.setStyle(this.defaultStyle(layer.feature));
      if (layer.feature.properties.extraData) {
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      }
    });
    if (this.selectedLayer) {
      this.highlightFeature(this.selectedLayer);
    }
    this.map.invalidateSize();
    return true;
  }

  renderMap(countriesData, maximos) {
    let onCapaChange = this.props.onCapaChange;
    this.maximo = maximos[this.state.atributoSeleccionado];
    if (this.maximo.hasOwnProperty('nombre')) {
      this.maximo = this.maximo.valor;
    }
    this.countryColor = chroma
      // .scale(['#000', '#f00', '#ff0', '#ffa'])
      .scale('YlGnBu')
      .correctLightness()
      .mode('lch')
      .domain([0, this.maximo]);
    this.defaultStyle = function(feature) {
      const extraData = feature.properties.extraData;
      if (extraData) {
        let val = extraData[this.state.atributoSeleccionado];
        if (val.hasOwnProperty('nombre')) {
          val = extraData[this.state.atributoSeleccionado].valor;
        }
        let color = this.countryColor(val);

        return {
          fillColor: color,
          opacity: 1,
          weight: 1,
          color: borderColor,
          dashArray: '',
          fillOpacity: 1
        };
      } else {
        return {
          fillColor: fadedColor,
          opacity: 1,
          weight: 2,
          color: fadedColor,
          dashArray: '',
          fillOpacity: 1
        };
      }
    }.bind(this);
    this.highlightFeature = function(layer) {
      layer.setStyle({
        weight: 3,
        color: selectedBorderColor,
        dashArray: '',
        fillOpacity: 1
      });

      if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
        layer.bringToFront();
      }
    };
    this.zoomToWholeMap = function() {
      this.map.fitBounds([[-70, -180], [80, 180]]);
    }.bind(this);
    this.zoomToFeature = function(layer) {
      this.map.fitBounds(layer.getBounds(), {
        padding: [10, 10]
      });
    }.bind(this);
    this.onEachFeature = function(feature, layer) {
      feature.properties.extraData = countriesData[feature.properties.iso_a2];
      layer.setStyle(this.defaultStyle(layer.feature));
      if (layer.feature.properties.extraData) {
        // let marker = L.marker(layer.getBounds().getCenter()).addTo(this.map);
        // marker.bindTooltip('my tooltip text').openTooltip();
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      }
      layer.on({
        mouseover: e => {
          let layer = e.target;
          if (!(layer && layer.feature.properties.extraData)) {
            return;
          }
          this.highlightFeature(layer);
          if (this.selectedLayer) {
            this.highlightFeature(this.selectedLayer);
          }
          onCapaChange(layer);
        },
        mouseout: e => {
          let layer = e.target;
          if (!(layer && layer.feature.properties.extraData)) {
            return;
          }
          if (layer !== this.selectedLayer) {
            layer.setStyle(this.defaultStyle(layer.feature));
          }
          onCapaChange(this.selectedLayer);
        },
        click: e => {
          let layer = e.target;
          if (!(layer && layer.feature.properties.extraData)) {
            return;
          }
          if (layer !== this.selectedLayer) {
            if (this.selectedLayer) {
              this.selectedLayer.setStyle(this.defaultStyle(this.selectedLayer.feature));
            }
            this.selectedLayer = layer;
            this.highlightFeature(this.selectedLayer);
            this.zoomToFeature(this.selectedLayer);
          } else {
            if (this.selectedLayer) {
              this.selectedLayer.setStyle(this.defaultStyle(this.selectedLayer.feature));
            }
            this.selectedLayer = null;
            this.zoomToWholeMap();
          }
          onCapaChange(this.selectedLayer);
        }
      });
    }.bind(this);

    let mapContainer = ReactDOM.findDOMNode(this);
    this.map = new L.Map(mapContainer, {
      center: [4.624335, -74.063644],
      zoom: 1,
      maxBounds: [[-70, -180], [80, 180]],
      minZoom: 1.3,
      maxZoom: 5,
      layers: [],
      gestureHandling: true
    });
    this.geojson = L.geoJSON(countriesGeoJson, {
      onEachFeature: this.onEachFeature,
      style: this.defaultStyle
    }).addTo(this.map);
    this.geojson.eachLayer(layer => {
      layer.setStyle(this.defaultStyle(layer.feature));
      if (layer.feature.properties.extraData) {
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      }
    });
    if (this.selectedLayer) {
      this.highlightFeature(this.selectedLayer);
    }
    this.zoomToWholeMap();
    window.setTimeout(() => {
      this.map.invalidateSize();
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/components/Mapa.js